"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Replay = void 0;
const ReplayMap_1 = require("./ReplayMap");
const ReplayCustomMap_1 = require("./ReplayCustomMap");
const ReplayChunk_1 = require("./ReplayChunk");
const ReplayState_1 = require("./ReplayState");
const Reader_1 = require("../Reader");
const FrameDataReader_1 = require("./FrameDataReader");
const readDelta_1 = require("./readDelta");
const checkType = (r) => {
    let magic = r.nstr(8);
    return magic === 'HLDEMO';
};
const readHeader = (r) => ({
    demoProtocol: r.ui(),
    netProtocol: r.ui(),
    mapName: r.nstr(260),
    modName: r.nstr(260),
    mapCrc: r.i(),
    dirOffset: r.ui()
});
const readDirectories = (r, offset) => {
    r.seek(offset);
    let count = r.ui();
    let directories = [];
    for (let i = 0; i < count; ++i) {
        directories.push({
            id: r.ui(),
            name: r.nstr(64),
            flags: r.ui(),
            cdTrack: r.i(),
            time: r.f(),
            frames: r.ui(),
            offset: r.ui(),
            length: r.ui()
        });
    }
    return directories;
};
const readFrameData = (r, deltaDecoders, customMessages) => {
    let length = r.ui();
    let limit = r.tell() + length;
    let data = [];
    while (r.tell() < limit) {
        let type = r.ub();
        if (type === 1) {
            continue;
        }
        else if (type >= 64) {
            if (customMessages[type] && customMessages[type].size > -1) {
                r.skip(customMessages[type].size);
            }
            else {
                r.skip(r.ub());
            }
            continue;
        }
        let message = FrameDataReader_1.FrameDataReader.read(r, type, deltaDecoders);
        if (message) {
            if (type === 39) {
                customMessages[message.index] = message;
            }
            data.push({
                type,
                data: message
            });
        }
        else {
            r.seek(limit);
        }
    }
    r.seek(limit);
    return data;
};
const readFrame = (r, deltaDecoders, customMessages) => {
    let frame = {
        type: r.ub(),
        time: r.f(),
        tick: r.ui()
    };
    switch (frame.type) {
        case 0:
        case 1: {
            r.skip(4);
            frame.camera = {
                position: [r.f(), r.f(), r.f()],
                orientation: [r.f(), r.f(), r.f()]
            };
            r.skip(436);
            frame.data = readFrameData(r, deltaDecoders, customMessages);
            break;
        }
        case 2: {
            break;
        }
        case 3: {
            frame.command = r.nstr(64);
            break;
        }
        case 4: {
            r.skip(32);
            break;
        }
        case 5: {
            break;
        }
        case 6: {
            r.skip(84);
            break;
        }
        case 7: {
            r.skip(8);
            break;
        }
        case 8: {
            frame.sound = {
                channel: r.i(),
                sample: r.nstr(r.ui()),
                attenuation: r.f(),
                volume: r.f(),
                flags: r.ui(),
                pitch: r.i()
            };
            break;
        }
        case 9: {
            r.skip(r.ui());
            break;
        }
        default: {
            frame.error = true;
            break;
        }
    }
    return frame;
};
class Replay {
    constructor(header, directories) {
        this.header = header;
        this.mapName = this.header.mapName;
        this.directories = directories;
    }
    static parseFromArrayBuffer(buffer) {
        let r = new Reader_1.Reader(buffer);
        let magic = r.nstr(8);
        if (magic !== 'HLDEMO') {
            throw new Error('Invalid replay format');
        }
        let header = {};
        header.demoProtocol = r.ui();
        header.netProtocol = r.ui();
        header.mapName = r.nstr(260);
        header.modName = r.nstr(260);
        header.mapCrc = r.i();
        header.dirOffset = r.ui();
        r.seek(header.dirOffset);
        let directoryCount = r.ui();
        let directories = [];
        for (let i = 0; i < directoryCount; ++i) {
            directories.push({
                id: r.ui(),
                name: r.nstr(64),
                flags: r.ui(),
                cdTrack: r.i(),
                time: r.f(),
                frames: r.ui(),
                offset: r.ui(),
                length: r.ui(),
                macros: []
            });
        }
        for (let i = 0; i < directories.length; ++i) {
            r.seek(directories[i].offset);
            let isFinalMacroReached = false;
            while (!isFinalMacroReached) {
                let macro = {
                    type: r.b(),
                    time: r.f(),
                    frame: r.ui()
                };
                switch (macro.type) {
                    case 0:
                    case 1: {
                        r.skip(4);
                        macro.camera = {
                            position: [r.f(), r.f(), r.f()],
                            orientation: [r.f(), r.f(), r.f()]
                        };
                        r.skip(436);
                        r.skip(r.ui());
                        break;
                    }
                    case 2: {
                        break;
                    }
                    case 3: {
                        macro.command = r.nstr(64);
                        break;
                    }
                    case 4: {
                        r.skip(32);
                        break;
                    }
                    case 5: {
                        isFinalMacroReached = true;
                        break;
                    }
                    case 6: {
                        r.skip(84);
                        break;
                    }
                    case 7: {
                        r.skip(8);
                        break;
                    }
                    case 8: {
                        r.skip(4);
                        r.skip(r.ui() + 16);
                        break;
                    }
                    case 9: {
                        r.skip(r.ui());
                        break;
                    }
                    default: {
                        const offset = Number(r.tell() - 9).toString(16);
                        const msg = [
                            `Unexpected macro (${macro.type})`,
                            ` at offset = ${offset}.`
                        ].join('');
                        throw new Error(msg);
                    }
                }
                directories[i].macros.push(macro);
            }
        }
        return new Replay(header, directories);
    }
    static parseFullFromArrayBuffer(buffer) {
        let r = new Reader_1.Reader(buffer);
        let magic = r.nstr(8);
        if (magic !== 'HLDEMO') {
            throw new Error('Invalid replay format');
        }
        let header = {};
        header.demoProtocol = r.ui();
        header.netProtocol = r.ui();
        header.mapName = r.nstr(260);
        header.modName = r.nstr(260);
        header.mapCrc = r.i();
        header.dirOffset = r.ui();
        r.seek(header.dirOffset);
        let directoryCount = r.ui();
        let directories = [];
        for (let i = 0; i < directoryCount; ++i) {
            directories.push({
                id: r.ui(),
                name: r.nstr(64),
                flags: r.ui(),
                cdTrack: r.i(),
                time: r.f(),
                frames: r.ui(),
                offset: r.ui(),
                length: r.ui(),
                macros: []
            });
        }
        let deltaDecoders = (0, readDelta_1.getInitialDeltaDecoders)();
        let customMessages = [];
        for (let i = 0; i < directories.length; ++i) {
            r.seek(directories[i].offset);
            let isFinalMacroReached = false;
            while (!isFinalMacroReached) {
                let macro = {
                    type: r.b(),
                    time: r.f(),
                    frame: r.ui()
                };
                switch (macro.type) {
                    case 0:
                    case 1: {
                        r.skip(4);
                        macro.camera = {
                            position: [r.f(), r.f(), r.f()],
                            orientation: [r.f(), r.f(), r.f()],
                            forward: [r.f(), r.f(), r.f()],
                            right: [r.f(), r.f(), r.f()],
                            up: [r.f(), r.f(), r.f()]
                        };
                        macro.RefParams = {
                            frametime: r.f(),
                            time: r.f(),
                            intermission: r.i(),
                            paused: r.i(),
                            spectator: r.i(),
                            onground: r.i(),
                            waterlevel: r.i(),
                            velocity: [r.f(), r.f(), r.f()],
                            origin: [r.f(), r.f(), r.f()],
                            viewHeight: [r.f(), r.f(), r.f()],
                            idealPitch: r.f(),
                            viewAngles: [r.f(), r.f(), r.f()],
                            health: r.i(),
                            crosshairAngle: [r.f(), r.f(), r.f()],
                            viewSize: r.f(),
                            punchAngle: [r.f(), r.f(), r.f()],
                            maxClients: r.i(),
                            viewEntity: r.i(),
                            playerCount: r.i(),
                            maxEntities: r.i(),
                            demoPlayback: r.i(),
                            hardware: r.i(),
                            smoothing: r.i(),
                            ptr_cmd: r.i(),
                            ptr_movevars: r.i(),
                            viewport: [r.i(), r.i(), r.i(), r.i()],
                            nextView: r.i(),
                            onlyClientDraw: r.i()
                        };
                        macro.UserCmd = {
                            lerp_msec: r.s(),
                            msec: r.ub(),
                            UNUSED1: r.ub(),
                            viewAngles: [r.f(), r.f(), r.f()],
                            forwardMove: r.f(),
                            sideMove: r.f(),
                            upMove: r.f(),
                            lightLevel: r.b(),
                            UNUSED2: r.ub(),
                            buttons: r.us(),
                            impulse: r.b(),
                            weaponSelect: r.b(),
                            UNUSED: r.s(),
                            impactIndex: r.i(),
                            impactPosition: [r.f(), r.f(), r.f()]
                        };
                        macro.MoveVars = {
                            gravity: r.f(),
                            stopSpeed: r.f(),
                            maxSpeed: r.f(),
                            spectatorMaxSpeed: r.f(),
                            acceleration: r.f(),
                            airAcceleration: r.f(),
                            waterAcceleration: r.f(),
                            friction: r.f(),
                            edgeFriction: r.f(),
                            waterFriction: r.f(),
                            entityGravity: r.f(),
                            bounce: r.f(),
                            stepSize: r.f(),
                            maxVelocity: r.f(),
                            zMax: r.f(),
                            waveHeight: r.f(),
                            footsteps: r.i(),
                            skyName: r.nstr(32),
                            rollAngle: r.f(),
                            rollSpeed: r.f(),
                            skyColor: [r.f(), r.f(), r.f()],
                            skyVec: [r.f(), r.f(), r.f()]
                        };
                        macro.view = [r.f(), r.f(), r.f()];
                        macro.viewModel = r.i();
                        macro.incoming_sequence = r.i();
                        macro.incoming_acknowledged = r.i();
                        macro.incoming_reliable_acknowledged = r.i();
                        macro.incoming_reliable_sequence = r.i();
                        macro.outgoing_sequence = r.i();
                        macro.reliable_sequence = r.i();
                        macro.last_reliable_sequence = r.i();
                        let frameDataLength = r.ui();
                        let frameDataEnd = frameDataLength + r.tell();
                        macro.frameData = [];
                        while (r.tell() < frameDataEnd) {
                            let type = r.ub();
                            if (type === 1) {
                                continue;
                            }
                            else if (type >= 64) {
                                if (customMessages[type] && customMessages[type].size > -1) {
                                    r.skip(customMessages[type].size);
                                }
                                else {
                                    r.skip(r.ub());
                                }
                                continue;
                            }
                            let frameData = FrameDataReader_1.FrameDataReader.read(r, type, deltaDecoders);
                            if (frameData) {
                                if (type === 39) {
                                    customMessages[frameData.index] = frameData;
                                }
                                macro.frameData.push({ type, frameData });
                            }
                            else {
                                r.seek(frameDataEnd);
                            }
                        }
                        r.seek(frameDataEnd);
                        break;
                    }
                    case 2: {
                        break;
                    }
                    case 3: {
                        macro.command = r.nstr(64);
                        break;
                    }
                    case 4: {
                        macro.clientData = {
                            position: [r.f(), r.f(), r.f()],
                            rotation: [r.f(), r.f(), r.f()],
                            weaponFlags: r.ui(),
                            fov: r.f()
                        };
                        break;
                    }
                    case 5: {
                        isFinalMacroReached = true;
                        break;
                    }
                    case 6: {
                        macro.event = {
                            flags: r.ui(),
                            index: r.ui(),
                            delay: r.f(),
                            args: {
                                flags: r.ui(),
                                entityIndex: r.ui(),
                                position: [r.f(), r.f(), r.f()],
                                rotation: [r.f(), r.f(), r.f()],
                                velocity: [r.f(), r.f(), r.f()],
                                ducking: r.ui(),
                                fparam1: r.f(),
                                fparam2: r.f(),
                                iparam1: r.i(),
                                iparam2: r.i(),
                                bparam1: r.i(),
                                bparam2: r.i()
                            }
                        };
                        break;
                    }
                    case 7: {
                        macro.weaponAnimation = {
                            animation: r.i(),
                            body: r.i()
                        };
                        break;
                    }
                    case 8: {
                        macro.sound = {
                            channel: r.i(),
                            sample: r.nstr(r.ui()),
                            attenuation: r.f(),
                            volume: r.f(),
                            flags: r.ui(),
                            pitch: r.i()
                        };
                        break;
                    }
                    case 9: {
                        r.skip(r.ui());
                        break;
                    }
                    default: {
                        const offset = Number(r.tell() - 9).toString(16);
                        const msg = `Unexpected macro (${macro.type}) at offset = ${offset}`;
                        throw new Error(msg);
                    }
                }
                directories[i].macros.push(macro);
            }
        }
        return new Replay(header, directories);
    }
    static parseCustomFile(buffer) {
        const data = new ReplayCustomMap_1.ReplayCustomMap();
        const view = new DataView(buffer);
        let offset = 0;
        const getString = (length) => {
            const chars = [];
            for (let i = 0; i < length; i++) {
                const charCode = view.getUint8(offset++);
                if (charCode !== 0)
                    chars.push(String.fromCharCode(charCode));
            }
            return chars.join('');
        };
        const timestamp = view.getBigInt64(offset, true);
        offset += 8;
        const version = view.getUint16(offset);
        offset += 2;
        const map = getString(32);
        const time = (view.getUint8(offset) << 16) |
            (view.getUint8(offset + 1) << 8) |
            view.getUint8(offset + 2);
        offset += 3;
        const name = getString(32);
        const steamid = getString(24);
        const additionalInfo = getString(32);
        data.header = {
            timestamp,
            version,
            map,
            time,
            name,
            steamid,
            additionalInfo
        };
        data.time = time;
        console.log(data.header);
        let prevFrame = null;
        while (offset < buffer.byteLength) {
            const flags = (view.getUint8(offset) << 16) |
                (view.getUint8(offset + 1) << 8) |
                view.getUint8(offset + 2);
            offset += 3;
            const frame = {
                timestamp: 0,
                origin: [0, 0, 0],
                rotation: [0, 0],
                speed: 0,
                buttons: 0,
                fps: 0,
                strafes: 0,
                sync: 0,
                grounded: false,
                gravity: false,
            };
            if (!prevFrame) {
                frame.timestamp = view.getUint8(offset++);
                for (let i = 0; i < 3; i++) {
                    frame.origin[i] = view.getInt16(offset, false) / 4;
                    offset += 2;
                }
                for (let i = 0; i < 2; i++) {
                    frame.rotation[i] = view.getInt16(offset, false) / 5;
                    offset += 2;
                }
                frame.speed = view.getInt16(offset, false);
                offset += 2;
                frame.buttons = view.getUint8(offset++);
                frame.fps = view.getUint8(offset++) * 4;
                frame.strafes = view.getUint8(offset++);
                frame.sync = view.getUint8(offset++);
                frame.grounded = !!(flags & (1 << 11));
                frame.gravity = !!(flags & (1 << 12));
                data.addFrame(frame);
                prevFrame = frame;
                continue;
            }
            const rleFlag = !!(flags & (1 << 0));
            if (rleFlag && prevFrame) {
                Object.assign(frame, prevFrame);
                continue;
            }
            const delta = view.getInt8(offset++);
            frame.timestamp = prevFrame.timestamp + delta;
            for (let i = 0; i < 3; i++) {
                const fullValue = !!(flags & (1 << (i + 1)));
                if (fullValue) {
                    frame.origin[i] = prevFrame.origin[i] + view.getInt16(offset, false) / 4;
                    offset += 2;
                }
                else {
                    const delta = view.getInt8(offset++) / 4;
                    frame.origin[i] = prevFrame.origin[i] + delta;
                }
            }
            for (let i = 0; i < 2; i++) {
                const fullValue = !!(flags & (1 << (i + 4)));
                if (fullValue) {
                    frame.rotation[i] = (prevFrame.rotation[i] + view.getInt16(offset, false) / 5) % 360;
                    offset += 2;
                }
                else {
                    const delta = view.getInt8(offset++) / 5;
                    frame.rotation[i] = (prevFrame.rotation[i] + delta) % 360;
                }
            }
            const speedFullValue = !!(flags & (1 << 6));
            if (speedFullValue) {
                frame.speed = prevFrame.speed + view.getInt16(offset, false);
                offset += 2;
            }
            else {
                const delta = view.getInt8(offset++);
                frame.speed = prevFrame.speed + delta;
            }
            const buttonsChanged = !!(flags & (1 << 7));
            if (buttonsChanged) {
                frame.buttons = view.getUint8(offset++);
            }
            else {
                frame.buttons = prevFrame.buttons;
            }
            const fpsChanged = !!(flags & (1 << 8));
            if (fpsChanged) {
                frame.fps = view.getUint8(offset++) * 4;
            }
            else {
                frame.fps = prevFrame.fps;
            }
            const strafesChanged = !!(flags & (1 << 9));
            if (strafesChanged) {
                frame.strafes = view.getUint8(offset++);
            }
            else {
                frame.strafes = prevFrame.strafes;
            }
            const syncChanged = !!(flags & (1 << 10));
            if (syncChanged) {
                frame.sync = view.getUint8(offset++);
            }
            else {
                frame.sync = prevFrame.sync;
            }
            frame.grounded = !!(flags & (1 << 11));
            frame.gravity = !!(flags & (1 << 12));
            data.addFrame(frame);
            prevFrame = frame;
        }
        return { data };
    }
    static parseIntoChunks(buffer) {
        let r = new Reader_1.Reader(buffer);
        if (!checkType(r)) {
            throw new Error('Invalid replay file format');
        }
        let maps = [];
        let deltaDecoders = (0, readDelta_1.getInitialDeltaDecoders)();
        let customMessages = [];
        let header = readHeader(r);
        let directories = readDirectories(r, header.dirOffset);
        let currentMap;
        let currentChunk;
        let lastFrame;
        let lastFrameOffset;
        let state = new ReplayState_1.ReplayState();
        let directoryEndOffset;
        directoryEndOffset = directories[0].offset + directories[0].length;
        r.seek(directories[0].offset);
        while (r.tell() < directoryEndOffset) {
            let frame = readFrame(r, deltaDecoders, customMessages);
            state.feedFrame(frame);
            if (frame.error) {
                throw new Error('Encountered error while reading replay');
            }
            if (frame.type < 2) {
                let serverInfo = frame.data.find((msg) => msg.type === FrameDataReader_1.FrameDataReader.SVC.SERVERINFO);
                if (serverInfo) {
                    currentMap = new ReplayMap_1.ReplayMap(serverInfo.data.mapFileName);
                    maps.push(currentMap);
                }
                let resourceList = frame.data.find((msg) => msg.type === FrameDataReader_1.FrameDataReader.SVC.RESOURCELIST);
                if (resourceList && currentMap) {
                    currentMap.setResources(resourceList.data);
                }
            }
        }
        if (!(currentMap instanceof ReplayMap_1.ReplayMap)) {
            throw new Error('Error while parsing replay.');
        }
        lastFrameOffset = r.tell();
        currentChunk = new ReplayChunk_1.ReplayChunk(state, 0);
        currentMap.addChunk(currentChunk);
        directoryEndOffset = directories[1].offset + directories[1].length;
        r.seek(directories[1].offset);
        while (true) {
            let offset = r.tell();
            if (offset >= directoryEndOffset) {
                let timeLength = lastFrame.time - currentChunk.startTime;
                currentChunk.timeLength = timeLength;
                let lastFrameLength = offset - lastFrameOffset;
                r.seek(lastFrameOffset);
                currentChunk.setData(r.arrx(lastFrameLength, Reader_1.ReaderDataType.UByte));
                r.seek(offset);
                break;
            }
            let frame = readFrame(r, deltaDecoders, customMessages);
            state.feedFrame(frame);
            lastFrame = frame;
            if (frame.error) {
                throw new Error('Encountered error while reading replay');
            }
            if (frame.type < 2) {
                let serverInfo = frame.data.find((msg) => msg.type === FrameDataReader_1.FrameDataReader.SVC.SERVERINFO);
                if (serverInfo) {
                    currentMap = new ReplayMap_1.ReplayMap(serverInfo.data.mapFileName);
                    maps.push(currentMap);
                    let timeLength = lastFrame.time - currentChunk.startTime;
                    currentChunk.timeLength = timeLength;
                    let lastFrameLength = offset - lastFrameOffset;
                    let tempOffset = r.tell();
                    r.seek(lastFrameOffset);
                    currentChunk.setData(r.arrx(lastFrameLength, Reader_1.ReaderDataType.UByte));
                    r.seek(tempOffset);
                    lastFrameOffset = offset;
                    currentChunk = new ReplayChunk_1.ReplayChunk(state, frame.time);
                    currentMap.addChunk(currentChunk);
                }
                let resourceList = frame.data.find((msg) => msg.type === FrameDataReader_1.FrameDataReader.SVC.RESOURCELIST);
                if (resourceList) {
                    currentMap.setResources(resourceList.data);
                }
                if (serverInfo) {
                    continue;
                }
                for (let i = 0; i < frame.data.length; ++i) {
                    let message = frame.data[i];
                    if (message.type === FrameDataReader_1.FrameDataReader.SVC.SOUND ||
                        message.type === FrameDataReader_1.FrameDataReader.SVC.SPAWNSTATICSOUND) {
                        let sound = currentMap.resources.sounds.find((s) => s.index === message.data.soundIndex);
                        if (sound) {
                            sound.used = true;
                        }
                    }
                    else if (message.type === FrameDataReader_1.FrameDataReader.SVC.STUFFTEXT) {
                        let sounds = currentMap.resources.sounds;
                        let commands = message.data.commands;
                        for (let i = 0; i < commands.length; ++i) {
                            let command = commands[i];
                            let func = command.func;
                            if ((func === 'speak' || func === 'spk') &&
                                command.params.length === 1) {
                                let soundName = command.params[0] + '.wav';
                                let sound = sounds.find((s) => s.name === soundName);
                                if (sound) {
                                    sound.used = true;
                                }
                            }
                        }
                    }
                }
            }
            else if (frame.type === 8) {
                let sound = currentMap.resources.sounds.find((s) => s.name === frame.sound.sample);
                if (sound) {
                    sound.used = true;
                }
            }
            if (currentChunk.startTime + 10 < frame.time) {
                let lastFrameLength = offset - lastFrameOffset;
                let tempOffset = r.tell();
                r.seek(lastFrameOffset);
                currentChunk.setData(r.arrx(lastFrameLength, Reader_1.ReaderDataType.UByte));
                r.seek(tempOffset);
                lastFrameOffset = offset;
                currentChunk = new ReplayChunk_1.ReplayChunk(state, frame.time);
                currentMap.addChunk(currentChunk);
            }
        }
        return {
            length: directories[1].time,
            maps,
            deltaDecoders,
            customMessages
        };
    }
    static readHeader(r) {
        return readHeader(r);
    }
    static readDirectories(r, offset) {
        return readDirectories(r, offset);
    }
    static readFrame(r, deltaDecoders, customMessages) {
        return readFrame(r, deltaDecoders, customMessages);
    }
    static readFrameData(r, deltaDecoders, customMessages) {
        return readFrame(r, deltaDecoders, customMessages);
    }
}
exports.Replay = Replay;
